import { render, staticRenderFns } from "./productBuy.vue?vue&type=template&id=8762039c&scoped=true&%3Ais=view&transition=fade&transition-mode=out-in&"
import script from "./productBuy.vue?vue&type=script&lang=js&"
export * from "./productBuy.vue?vue&type=script&lang=js&"
import style0 from "./productBuy.vue?vue&type=style&index=0&id=8762039c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8762039c",
  null
  
)

export default component.exports